export async function getFilesFromPath() {
  throw new Error('Unsupported in this environment');
}
export async function* filesFromPath() {
  throw new Error('Unsupported in this environment');
}